import React from 'react';

const FixedProcessLoader = () => {
    return (
        <div className="oi-loader__fixed">
            <div className="oi-loader">
                <svg className="oi-loader__svg" viewBox="0 0 80 80">
                    <circle className="oi-loader__circle" id="test" cx="40" cy="40" r="32"></circle>
                </svg>
            </div>

            <div className="oi-loader__msg">One Moment..</div>
        </div>
    );
};

export default FixedProcessLoader;
